/**
 * Returns `true` if the argument is either `null` or `undefined`, or `false` otherwise.
 *
 * https://developer.mozilla.org/en-US/docs/Glossary/Nullish
 */
export const isNullish = (arg: unknown): arg is null | undefined =>
  arg === null || arg === undefined;
